import React from "react"
import { Helmet } from "react-helmet"
import { Link } from "gatsby"
import {
  SwanProvider,
  SwanHead,
  SWAN_STYLE_KEY_MAP,
  SWAN_BASE_URL_MAP,
  useBrowserClasses,
  getRootClassNames,
} from "@vp/swan"
import { BookendsMetaTag, BOOKENDS_SWAN_STYLES, BOOKEND_TYPES } from '@vp/esi-bookends'

const styleKeys = [
  ...BOOKENDS_SWAN_STYLES,
  SWAN_STYLE_KEY_MAP.button,
  SWAN_STYLE_KEY_MAP.accordion,
  SWAN_STYLE_KEY_MAP.grid,
  SWAN_STYLE_KEY_MAP.modalDialog,
  SWAN_STYLE_KEY_MAP.hidden,
  SWAN_STYLE_KEY_MAP.icon,
  SWAN_STYLE_KEY_MAP.toggleSwitch,
  SWAN_STYLE_KEY_MAP.core,
  SWAN_STYLE_KEY_MAP.visible,
  SWAN_STYLE_KEY_MAP.standardTile,
  SWAN_STYLE_KEY_MAP.progressiveImage,
  SWAN_STYLE_KEY_MAP.utility,
  SWAN_STYLE_KEY_MAP.popover
]

export const SwanConfiguration = ({locale, tenant, children }) => {
  const browser = useBrowserClasses()
  const rootClassName = getRootClassNames()
  return (
    <SwanProvider swanBaseUrl={SWAN_BASE_URL_MAP.default.cdn} globalLinkComponent={Link}>
      <Helmet
        htmlAttributes={{ class: browser }}
        bodyAttributes={{ class: rootClassName }}
      />
      <SwanHead
        renderStyleContentAsChildren
        renderWith={Helmet}
        styleSheetKeys={styleKeys}
      />
      <BookendsMetaTag
        renderWith={Helmet}
        inlineCriticalCss={true}
        locale={locale}
        tenant={tenant}
        headerType={BOOKEND_TYPES.FULL}
        footerType={BOOKEND_TYPES.FULL}
        hideSearch={false} 
        hideVat={false}
      />
      {children}
    </SwanProvider>
  )
}
